module.exports = __webpack_public_path__ + "img/logoapart.6abcbaa4.png";